// PageVariablesSegurados.js

export const pageVariables = {

    headers: [
        'NOME DO ARQUIVO', 'STATUS','CRIADO EM'
    ],
    headerInfo: {
        title: "Página de Uploads",
        description: "Nesta seção, você encontra informações detalhadas sobre os arquivos de upload, incluindo status, data de envio e resultados do processamento. Acompanhe o histórico de uploads para garantir o rastreamento e a gestão eficiente dos dados."
    },
    inputs: [
        {
            name: "rg",
            type: "text",
            label: "Status"
        },
        {
            name: "email",
            type: "text",
            label: "Comentario"
        },
    ]
    ,
    page: process.env.VUE_APP_API_URL+"uploads",
};
